/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Compatibility_WindowsInputs */

const en_downloads_compatibility_windows = /** @type {(inputs: Downloads_Compatibility_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires Windows 10 or later, 64-bit.`)
};

const es_downloads_compatibility_windows = /** @type {(inputs: Downloads_Compatibility_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere Windows 10 o posterior, 64 bits.`)
};

/**
* | output |
* | --- |
* | "Requires Windows 10 or later, 64-bit." |
*
* @param {Downloads_Compatibility_WindowsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_compatibility_windows = /** @type {((inputs?: Downloads_Compatibility_WindowsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Compatibility_WindowsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_compatibility_windows(inputs)
	return en_downloads_compatibility_windows(inputs)
});